import { captureException } from '@sentry/react'
import { z } from 'zod'
import axios from '@/axios-instance-node'
import { GetSubgeosSchema } from '@/features/subgeo/types.ts'
import { parseResponseData } from '@/helpers/utils'
import type { ResponseType } from '@/types.ts'

export interface HttpGetSubgeosParams {
	geoId: string
	responseType: ResponseType
	limit?: number
	page?: number
	name?: string
}

const DirectSubgeoArrayResponse = z.array(GetSubgeosSchema)

export const httpGetSubgeos = async (params: HttpGetSubgeosParams) => {
	const requestParams: Record<string, unknown> = {
		geoId: params.geoId,
		responseType: params.responseType
	}

	if (params.limit !== undefined) {
		requestParams.limit = params.limit
	}

	if (params.page !== undefined) {
		requestParams.page = params.page
	}

	if (params.name !== undefined) {
		requestParams.name = params.name
	}

	const response = await axios.get('/v1/geo-mapping-sub-geos', {
		params: requestParams
	})

	const parsedData = parseResponseData({
		responseData: response.data,
		responseShape: DirectSubgeoArrayResponse,
		onZodError: captureException
	})

	return {
		meta: {
			page: 1,
			limit: parsedData.length,
			total: parsedData.length,
			totalPages: 1
		},
		data: parsedData
	}
}

export interface HttpGetSubgeosResponse {
	meta: {
		page: number
		limit: number
		total: number
		totalPages: number
	}
	data: z.infer<typeof GetSubgeosSchema>[]
}
